import vxProfileCard from '../../common/vx-profile-card/vx-profile-card.vue';
import vxTaxExemption from '../vx-tax-exemption/vx-tax-exemption.vue';
import vxCommunicationPreferences from '../vx-communication-preferences/vx-communication-preferences.vue';
import vxSocialDisconnect from '../vx-social-disconnect/vx-social-disconnect.vue';
import vxModal from '../../common/vx-modal/vx-modal.vue';
import vxChangePassword from '../vx-change-password/vx-change-password.vue';
import vxEditPersonalDetails from '../vx-edit-personal-details/vx-edit-personal-details.vue';
import vxFacebookLogin from '../../registration-login/vx-facebook-login/vx-facebook-login.vue';
import vxGoogleLogin from '../../registration-login/vx-google-login/vx-google-login.vue';
import globals from '../../common/globals';
import flyoutBannerMixin from '../../common/vx-flyout-banner/vx-flyout-banner-mixin';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import {
  socialAccountType,
  socialConnect,
  UserRoles,
  logoutFlowCookie,
  googleErrorResponse,
  monthNames,
  dateSuffix,
  PreferNotToIdentify,
  singleDigitDate,
} from '../../common/mixins/vx-enums';
import ManageProfileShoppingListService from '../../common/services/manage-profile-shopping-lists-service';
import PardotService from '../../common/services/pardot-service';

export default {
  name: 'vx-profile-preferences',
  mixins: [flyoutBannerMixin],
  components: {
    'vx-profile-card': vxProfileCard,
    'vx-tax-exemption': vxTaxExemption,
    'vx-communication-preferences': vxCommunicationPreferences,
    vxModal,
    vxSpinner,
    vxChangePassword,
    vxEditPersonalDetails,
    vxSocialDisconnect,
    vxFacebookLogin,
    vxGoogleLogin,
  },
  props: {
    /**
     * Labels, button and caption texts
     */
    i18n: {
      type: Object,
      required: true,
    },
    /**
     * Boolean to show Tax Exemption card
     */
    showTaxExemption: {
      type: Boolean,
      default: false,
    },
    /**
     * Boolean to check if Gender data is available for the user
     */
    isGenderEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Boolean to check if Date of birth data is available for the user
     */
    isDobEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Boolean to show social login card
     */
    showSocialLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userDetails: {},
      globals,
      appToken: '',
      isSocialLogin: false,
      isGoogleLogin: false,
      isFacebookLogin: false,
      taxExemptionStatus: '',
      socialAccount: '',
      userRole: '',
      monthSuffix: '',
      dateSuffix,
      dateDisplay: '',
      genderDetails: '',
      PreferNotToIdentify,
      preferNotToIdentify: 'Prefer not to identify',
      manageProfileShoppingListService: new ManageProfileShoppingListService(),
      communicationPreferencesMessage: null,
      PardotService: new PardotService(),
    };
  },
  computed: {},
  mounted() {
    this.getUserDetails();
  },
  watch: {
    userDetails: {
      handler() {
        if (this.globals.isB2B()) {
          this.getPardotProspect();
        }
      },
      deep: true,
    },
  },
  methods: {
     /**
     * This function is to show spinner
     */
    showSpinner() {
      this.$refs.profileSpinner.showSpinner();
    },
    /**
     * This function is to hide spinner
     */
    hideSpinner() {
      this.$refs.profileSpinner.hideSpinner();
    },
     /**
     * This function is to get user details
     */
    getUserDetails() {
      const requestConfig = {};
      this.manageProfileShoppingListService.getUserDetails(
        requestConfig,
        this.handleUserDetailsResponse,
        this.handleUserDetailsError,
      );
      this.$refs.profileSpinner.showSpinner();
    },

    getPardotProspect() {
      this.$refs.profileSpinner.showSpinner();
      const { uid } = this.userDetails;
      this.PardotService.readProspectWithEmail(uid, this.handleCommunicationPreferences, this.handleCommunicationPreferencesError);
    },
    handleCommunicationPreferences(response) {
      this.$refs.profileSpinner.hideSpinner();
      if (response) {
        if (this.globals.isB2B()) {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(response, 'text/xml');
          const status = xmlDoc.getElementsByTagName('rsp')[0].getAttribute('stat');
          const optedOut = xmlDoc.getElementsByTagName('opted_out')[0].innerHTML === '1';
          if (status === 'ok') {
            if (optedOut) {
              // user has already opted-out
              this.communicationPreferencesMessage = this.i18n.marketingChoicesOptedOut;
            } else {
              // user has opted-in
              this.communicationPreferencesMessage = this.i18n.marketingChoices;
            }
          }
        }
      }
    },

    handleCommunicationPreferencesError(response) {
      this.$refs.profileSpinner.hideSpinner();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(response, 'text/xml');
      const status = xmlDoc.getElementsByTagName('rsp')[0].getAttribute('stat');
      if (status === 'fail') {
        // user profile does not exist
        const code = xmlDoc.getElementsByTagName('err')[0].getAttribute('code');
        if (code === '4') {
          this.communicationPreferencesMessage = this.i18n.marketingChoicesFalse;
        }
      }
    },

    /**
     * This function is to get tax exemption status
     */
    getTaxExemptionStatus() {
      const requestConfig = {};
      this.manageProfileShoppingListService.getTaxExemptionStatus(
        requestConfig,
        this.handleGetTaxExemption,
        this.handleGetTaxExemptionError,
      );
      this.$refs.profileSpinner.showSpinner();
    },
    /**
     * This function is to open tax exemption modal
     */
    callTaxExemptionModal(event) {
      this.$refs.taxExemptionModal.open(event);
    },
    /**
     * This function is to open communication preferences modal
     */
    callCommunicationPreferencesModal(event) {
      this.$refs.communicationPreferencesModal.open(event);
    },
    /**
     * This function is to do google login
     */
    googleLogin() {
      this.socialAccount = socialAccountType.GOOGLE;
      this.$refs.googleLogin.googleLogin();
    },
    /**
     * This function is to do facebook login
     */
    facebookLogin() {
      this.socialAccount = socialAccountType.FACEBOOK;
      this.$refs.facebookLogin.facebookLogin();
    },
    // Facebook response gets Accesstoken in data which we need to pass in request data to backend
    // On decription of accesstoken we will get user data.
    // It contains isSocialLogin flag that will be true
    // if user tries to login/register through facebook or google
    facebookResponse(data) {
      this.appToken = data.accessToken;
      this.connectToSocialAccount();
    },
    // Handling error method
    facebookErrorResponse(error) {
      this.showFlyout('error', error.message, true, 10000);
    },
    // Google response gets authcode in data which we need to pass in request
    // data along with isSocialLogin flag to backend On decription of authcode
    // we will get user data.
    googleResponse(data) {
      this.appToken = data;
      this.connectToSocialAccount();
    },
    // Handling error method
    googleErrorResponse(error) {
      if (error !== googleErrorResponse.popUpClosedError) {
        this.showFlyout('error', error, true, 10000);
      }
    },
    /**
     * This function is to disconnect google login
     */
    disconnectGoogleLogin(event) {
      this.socialAccount = socialAccountType.GOOGLE;
      this.$refs.socialAccDisconnectModal.open(event);
    },
    /**
     * This function is to disconnect facebook login
     */
    disconnectFacebookLogin(event) {
      this.socialAccount = socialAccountType.FACEBOOK;
      this.$refs.socialAccDisconnectModal.open(event);
    },
    /**
     * This function is to connect to social account
     */
    connectToSocialAccount() {
      const requestObj = {
        uid: this.userDetails.uid,
        loginType: this.socialAccount.toLowerCase(),
        token: this.appToken,
        password: socialConnect.password,
      };
      const requestConfig = {};
      requestConfig.data = requestObj;
      this.manageProfileShoppingListService.connectSocialAccount(
        requestConfig,
        this.handleConnectSocialAccount,
        this.handleConnectSocialAccountError,
      );
      this.$refs.profileSpinner.showSpinner();
    },
    /**
     * This function is to open update password modal
     */
    callUpdatePasswordModal(event) {
      this.$refs.updatePasswordModal.open(event);
    },
    /**
     * This function is to open edit personal details modal
     */
    callEditPersonalDetailsModal(event) {
      this.$refs.editPersonalDetailsModal.open(event);
    },
    /**
     * This function is to handle get user details response
     */
    handleUserDetailsResponse(response) {
      this.userDetails = response.data;
      if (this.userDetails.roles && this.userDetails.roles.length) {
        if (this.userDetails.roles[0] === UserRoles.ADMIN) {
          this.userRole = UserRoles.DISPLAY_ADMIN;
        } else {
          this.userRole = UserRoles.DISPLAY_BUYER;
        }
      }
      this.userDetails.uid = response.data.uid.split('|')[0];
      if (
        response.data.gender &&
        response.data.gender === this.PreferNotToIdentify.otherGender
      ) {
        this.genderDetails = this.preferNotToIdentify;
      } else {
        this.genderDetails = response.data.gender;
      }
      if (response.data.dateOfBirth) {
        this.userDetails.date = response.data.dateOfBirth.split('-')[0];
        if (singleDigitDate.indexOf(this.userDetails.date) > -1) {
          this.dateDisplay = this.userDetails.date.replace(/0/g, '');
        } else {
          this.dateDisplay = this.userDetails.date;
        }
        this.userDetails.month = response.data.dateOfBirth.split('-')[1];
        this.userDetails.monthName =
          monthNames[parseInt(response.data.dateOfBirth.split('-')[1]) - 1];
        switch (this.userDetails.date) {
          case '01':
          case '21':
          case '31':
            this.monthSuffix = this.dateSuffix.first;
            break;
          case '02':
          case '22':
            this.monthSuffix = this.dateSuffix.second;
            break;
          case '03':
          case '23':
            this.monthSuffix = this.dateSuffix.third;
            break;
          default:
            this.monthSuffix = this.dateSuffix.other;
        }
      }
      this.setLoginType();
      if (this.globals.isB2B()) {
        this.getTaxExemptionStatus();
      } else {
        this.$refs.profileSpinner.hideSpinner();
      }
    },
    /**
     * This function is to handle get user details error
     */
    handleUserDetailsError(error) {
      if (error) {
        this.$refs.profileSpinner.hideSpinner();
      }
    },
     /**
     * This function is to handle get tax exemption status response
     */
    handleGetTaxExemption(response) {
      this.$refs.profileSpinner.hideSpinner();
      if (response.data) {
        this.taxExemptionStatus = response.data.toLowerCase().replace('_', ' ');
      }
    },
    /**
     * This function is to handle get tax exemption status error
     */
    handleGetTaxExemptionError(error) {
      this.$refs.profileSpinner.hideSpinner();
      if (error) {}
    },
    /**
     * This function is to handle connect social account response
     */
    handleConnectSocialAccount(response) {
      this.$refs.profileSpinner.hideSpinner();
      this.showFlyout('success', this.i18n.socialSuccesConnect, true, 10000);
      this.updateSocialLoginStatus();
      // Logout the user
      this.globals.logout(logoutFlowCookie.socialConnect);
    },
    /**
     * This function is to handle connect social account error
     */
    handleConnectSocialAccountError(response) {
      this.$refs.profileSpinner.hideSpinner();
      if (response) {
        this.showFlyout('error', response.message, true, 10000);
      }
    },
    /**
     * This function is to handle updated tax exemption failure
     */
    updatedTaxExemptionFailure(failure) {
      this.$refs.taxExemptionModal.close();
      this.showFlyout('error', failure, true, 10000);
    },
    /**
     * This function is to handle updated tax exemption success
     */
    updatedTaxExemptionSuccess(success) {
      this.hideSpinner();
      this.$refs.taxExemptionModal.close();
      this.getTaxExemptionStatus();
      this.showFlyout('success', success, true, 10000);
    },
    /**
     * This function is to handle updated personal details success
     */
    updatedPersonalDetailSuccess(success) {
      this.$refs.editPersonalDetailsModal.close();
      this.getUserDetails();
      this.showFlyout('success', success, true, 10000);
    },
    /**
     * This function is to handle updated password success
     */
    updatePasswordSuccess(success) {
      this.$refs.updatePasswordModal.close();
      this.showFlyout('success', success, true, 10000);
    },
     /**
     * This function is to handle updated communication preferences success
     */
    updatePreferencesSuccess(success) {
      this.$refs.communicationPreferencesModal.close();
      this.showFlyout('success', success, true, 10000);
      this.getUserDetails();
    },
    /**
     * This function is to handle disconnect social account error
     */
    updateDisconnectSocialAccError(error) {
      this.$refs.socialAccDisconnectModal.close();
      this.showFlyout('error', error, true, 10000);
    },
    /**
     * This function is to handle disconnect social account success
     */
    updateDisconnectSocialAccSuccess(success) {
      this.resetSocialAccountData();
      this.$refs.socialAccDisconnectModal.close();
      this.showFlyout('success', success, true, 10000);
      // Logout the user
      this.globals.logout(logoutFlowCookie.socialDisconnect);
    },
    /**
     * This function is to reset social account data
     */
    resetSocialAccountData() {
      this.isSocialLogin = false;
      this.isGoogleLogin = false;
      this.isFacebookLogin = false;
    },
    /**
     * This function is to update social login status
     */
    updateSocialLoginStatus() {
      this.isSocialLogin = true;
      if (
        this.socialAccount.toLowerCase() ===
        socialAccountType.GOOGLE.toLowerCase()
      ) {
        this.isGoogleLogin = true;
        this.isFacebookLogin = false;
      } else {
        this.isGoogleLogin = false;
        this.isFacebookLogin = true;
      }
    },
     /**
     * This function is to set login type
     */
    setLoginType() {
      const {
        loginType,
      } = {
        ...this.userDetails,
      };
      if (
        loginType === socialAccountType.GOOGLE.toLowerCase() ||
        loginType === socialAccountType.FACEBOOK.toLowerCase()
      ) {
        this.socialAccount =
          loginType.charAt(0).toUpperCase() +
          loginType.substr(1, loginType.length);
        this.updateSocialLoginStatus();
      } else {
        this.isSocialLogin = false;
      }
    },
     /**
     * This function is to update login type
     */
    updateLoginType() {
      this.socialAccount =
        this.socialAccount.charAt(0).toUpperCase() +
        this.socialAccount.substr(1, this.socialAccount.length);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/manage-profile-shopping-lists/vx-profile-preferences/vx-profile-preferences.js